import { Workspace } from "@/types/workspace";

/**
 * Generates the query string for API requests that require a workspace_id.
 * Appends `workspace_id` if the active workspace is not personal.
 * 
 * @param activeWorkspace - The currently active workspace.
 * @returns A query string starting with '?' if applicable, or an empty string.
 */
export const getWorkspaceQueryString = (activeWorkspace: Workspace | null): string => {
    const params = new URLSearchParams();
    if (activeWorkspace) {
        params.append('workspace_id', activeWorkspace.id);
    }
    return params.toString() ? `?${params.toString()}` : '';
};
